import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Keep users signed in: on an expired access token, renew once via the refresh cookie and retry.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status !== 401 || cfg?._retried || /\/auth\/(login|register|refresh|logout)/.test(url)) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(cfg);
    } catch (_) {
      return Promise.reject(error);
    }
  }
);

// american odds -> decimal multiplier
export const toDecimal = (odds) => (odds >= 0 ? odds / 100 + 1 : 100 / Math.abs(odds) + 1);

export const fmtOdds = (odds) => (odds >= 0 ? `+${odds}` : `${odds}`);

// Local 12-hour game time from an ISO UTC commence time, e.g. "Oct 13, 7:05 PM".
// Converts to the viewer's own timezone so night games no longer show as midnight UTC.
export const formatGameTime = (iso, fallback = "TBD") => {
  if (!iso) return fallback;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return fallback;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
